export default class UitgevoerdeTaak {

  static deserialize(dto: UitgevoerdeTaakDto): UitgevoerdeTaak {
    return new UitgevoerdeTaak(
      dto.dienstId,
      dto.categorieId,
      dto.taakId,
      new Date(dto.tijdstip),
    );
  }

  static new(dienstId: string, categorieId: string, taakId: string): UitgevoerdeTaak {
    return new UitgevoerdeTaak(
      dienstId,
      categorieId,
      taakId,
      new Date(),
    );
  }

  constructor(
    private dienstId: string,
    private categorieId: string,
    private taakId: string,
    private tijdstip: Date
  ) {
  }

  getDienstId(): string {
    return this.dienstId;
  }

  hasDienstId(id: string): boolean {
    return this.dienstId === id;
  }

  getCategorieId(): string {
    return this.categorieId;
  }

  hasCategorieId(dienstId: string, categorieId: string): boolean {
    return this.dienstId === dienstId
      && this.categorieId === categorieId;
  }

  hasTaakId(dienstId: string, categorieId: string, taakId: string): boolean {
    return this.dienstId === dienstId
      && this.categorieId === categorieId
      && this.taakId === taakId;
  }

  hasCategorieEnTaakId(categorieId: string, taakId: string): boolean {
    return this.categorieId === categorieId
      && this.taakId === taakId;
  }

  getTaakId(): string {
    return this.taakId;
  }

  getTijdstip(): Date {
    return this.tijdstip;
  }
}

export interface UitgevoerdeTaakDto {
  dienstId: string;
  categorieId: string;
  taakId: string;
  tijdstip: string;
}
